import React from "react";
import { useSelector } from "react-redux";
import accessTokenSelector from "selectors/accessToken";

const LoginAccordianContent: React.FC = () => {
    const accessToken = useSelector(accessTokenSelector);

    return (
        <>
            <p>
                Simply click on the button below to open the Rend A Hand desktop
                app and log in.
            </p>
            <a
                id="openAndLogIn"
                className="btn btn-primary btn-sm btn-secondary"
                href={`rendahand://login?access_token=${accessToken}`}
            >
                Open and Log In
            </a>
        </>
    );
};

export default LoginAccordianContent;
